import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { useDynamicLocale } from '@/hoslog-intl';
import { MonthlyReportData } from '@/services/payment/payment.types';
import * as React from 'react';
import { MonthlyReportTableActionBar } from './ActionBar';
import { getColumns } from './Column';

export function MonthlyReportTable({ data }: { data: MonthlyReportData[] }) {
  const { t } = useDynamicLocale();
  const columns = React.useMemo(() => getColumns(t), [t]);

  const { table } = useDataTable({
    data,
    columns,
    pageCount: 0,
    initialState: {
      sorting: [{ id: 'id', desc: true }],
    },
    meta: {
      title: t('paymentManagement.affiliatePaymentLogs.monthlyReport.table.title'),
    },
    getRowId: (originalRow: MonthlyReportData) => String(originalRow.id),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table}>
        <DataTableToolbar />
        <MonthlyReportTableActionBar />
      </DataTable>
    </>
  );
}
